var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdficon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.86 1.7C48.67 0 45.48 0 39.09 0H14.9C8.52 0 5.33 0 3.14 1.7c-.54.42-1.02.9-1.43 1.43C0 5.33 0 8.52 0 14.9v24.19c0 6.38 0 9.58 1.7 11.77.42.54.9 1.02 1.43 1.43 2.19 1.7 5.38 1.7 11.77 1.7h24.19c6.38 0 9.58 0 11.77-1.7.54-.42 1.02-.9 1.43-1.43 1.7-2.19 1.7-5.38 1.7-11.77V14.9c0-6.38 0-9.58-1.7-11.77-.42-.54-.9-1.02-1.43-1.43z",
    fill: "#FAE7E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 37.8h4.567v-7.004h3.833c4.969 0 7.858-2.964 7.858-7.277 0-4.314-2.832-7.32-7.736-7.32H20.25v21.6zm4.567-10.664v-7.203h3.08a3.412 3.412 0 0 1 3.914 3.585 3.43 3.43 0 0 1-3.892 3.62l-3.102-.002z",
    fill: "#C0392B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.86 1.7C48.67 0 45.48 0 39.09 0H14.9C8.52 0 5.33 0 3.14 1.7c-.54.42-1.02.9-1.43 1.43C0 5.33 0 8.52 0 14.9v24.19c0 6.38 0 9.58 1.7 11.77.42.54.9 1.02 1.43 1.43 2.19 1.7 5.38 1.7 11.77 1.7h24.19c6.38 0 9.58 0 11.77-1.7.54-.42 1.02-.9 1.43-1.43 1.7-2.19 1.7-5.38 1.7-11.77V14.9c0-6.38 0-9.58-1.7-11.77-.42-.54-.9-1.02-1.43-1.43zm1.79 13.2v24.19c0 3.22 0 5.53-.2 7.3-.2 1.75-.58 2.82-1.21 3.64-.35.45-.75.85-1.2 1.2-.82.64-1.89 1.01-3.64 1.21-1.78.2-4.08.2-7.3.2H14.9c-3.22 0-5.53 0-7.3-.2-1.75-.2-2.82-.58-3.64-1.21-.45-.35-.85-.75-1.2-1.2-.64-.82-1.01-1.89-1.21-3.64-.2-1.78-.2-4.08-.2-7.3V14.9c0-3.22 0-5.53.2-7.3.2-1.75.58-2.82 1.21-3.64.35-.45.75-.85 1.2-1.2.82-.64 1.89-1.01 3.64-1.21 1.78-.2 4.08-.2 7.3-.2h24.19c3.22 0 5.53 0 7.3.2 1.75.2 2.82.58 3.64 1.21.45.35.85.75 1.2 1.2.64.82 1.01 1.89 1.21 3.64.2 1.78.2 4.08.2 7.3h.01z",
    fill: "#0C1523",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.2c8aa99decfd6cb4cf2dfe8c69964e63.svg";
export { ForwardRef as ReactComponent };